
<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  <a mat-tab-link *ngFor="let link of links" [routerLink]="link.path" routerLinkActive="subpage-active-link"
    #rla="routerLinkActive" [active]="rla.isActive">
    <span [class.tabActiveLink]="rla.isActive" (click)="onClick($event)">
      {{ link.label | translate }}
    </span>
  </a>
</nav>
<mat-tab-nav-panel #tabPanel>
  <ng-content></ng-content>
</mat-tab-nav-panel>